import { HttpService } from '../../services/HttpService';
import { store } from '../../configureStore';
import { apiUrls } from '../../constants/apiUrl';
import { getSecureBaseUrl } from '../../services/UrlMapperService';
import { setSession, throttleValueForMiniCartRedesign, isNSEJointOrSequentialFlow } from './Helpers';
import { CART_CONTACT_INFO_INTG } from './Helpers/constants';
import { getNetworkBandwidthType } from './addressUtils';

/**
 * Handles mini cart throttle flag for progressive plans
 * Sets the order summary revamp feature flag when FWA_MINICART_T_Plans is present
 * @param {string} throttleList - Comma/pipe separated list of throttle flags
 */
export const handleMiniCartThrottleFlag = (throttleList) => {
  if (throttleList?.includes('FWA_MINICART_T_Plans')) {
    setSession('enableOrderSummaryRevampFFlag', 'Y');
  }
   if (throttleList?.includes('FWA_MINICARTREDESIGNPHASE3_T_PLANS')) {
    setSession('isMiniCartPhase3Enabled', 'Y');
  }
};

const CallCradleAPI = (cradlePageName, currPageName) => {
  try {
    const networkBandwidthType = getNetworkBandwidthType();
    const properties = [
      { name: 'pageName', value: cradlePageName },
      { name: 'networkBandwidthType', value: networkBandwidthType },
    ];

    // Add enableMiniCartRedesign only for progressive plans page when throttle returns true
    if (currPageName === 'progressiveplan') {
      const enableMiniCartRedesign = throttleValueForMiniCartRedesign();
      if (enableMiniCartRedesign) {
        properties.push({ name: 'enableMiniCartRedesign', value: enableMiniCartRedesign });
        properties.push({ name: 'enableMiniCartRedesignPhase3', value: enableMiniCartRedesign });
      }
    }

    // Inform cradle if it's a joint or sequential flow
    if (currPageName === 'addons') {
      const isJointOrSequential = isNSEJointOrSequentialFlow();
      properties.push({ name: 'isJointOrSequentialFlow', value: isJointOrSequential });
    }

    const postData = { properties };

    const apiURL = `${getSecureBaseUrl()}${apiUrls().cradleApi}`;
    const apiResponse = HttpService.post(apiURL, postData);
    Promise.all([apiResponse]).then((res) => {
      if (res[0] && res[0].data && res[0].status === 200) {
        setSession('CradleResponse', 'Y');
        const throttleList = res?.[0]?.data?.throttleList || '';
        if (throttleList?.includes('FWA_Signin_T_Prompt_P')) {
          setTimeout(() => {
            const signInPromt = document.querySelectorAll('#fwa_signin_prompt_overlay');
            signInPromt.forEach((ele) => {
              const element = ele;
              element.style.display = 'none';
            });
          }, 3000);
        }
        switch (currPageName) {
          case 'cart':
          case 'expresscheckout':
            setSession(CART_CONTACT_INFO_INTG, throttleList?.includes('FWA_Cart_T_ContactInfo') ? 'Y' : 'N');
            break;
          case 'contactinfo':
            if (throttleList?.includes('FWA_Skip_T_Registration')) {
              setSession('skipReg', 'Y');
            }
            break;

          case 'shipping':
            if (throttleList?.includes('FWA_T_ServiceAddressDisplay')) {
              setSession('serviceAddressDisplay', 'Y');
            }
            store.dispatch({ type: 'SHIPPING_THROTTLE_VALUE', response: throttleList });
            break;
          case 'progressiveplan':
            handleMiniCartThrottleFlag(throttleList);
            break;

          default:
            break;
        }

        store.dispatch({ type: 'SIGNIN_CRADLE_VALUE', response: throttleList });
        store.dispatch({ type: 'CRADLE_API_COMPLETED', response: true });
        store.dispatch({ type: 'STORE_CRADLE_THROTTLE_VALUE', response: throttleList });
      }
    });
  } catch (error) {
    // error block
  }
};
export default CallCradleAPI;
